import t, { type TranslationKey } from "@ext/localization/locale/translate";
import { getInlineBlocker, type InlineBlocker } from "@ext/markdown/elements/image/edit/logic/convertToInline";
import type { Editor } from "@tiptap/core";
import { GlassToolbarButton, GlassToolbarIcon } from "@ui-kit/GlassToolbar";

const inlineBlockerReasons: Record<InlineBlocker, TranslationKey> = {
	"no-text": "disabled-reason.inline-image-no-text",
	"block-parts": "disabled-reason.inline-image-block-parts",
};

interface ImageToInlineButtonProps {
	editor: Editor;
	getPos: () => number;
}

const ImageToInlineButton = ({ editor, getPos }: ImageToInlineButtonProps) => {
	const label = t("block-to-inline-image");
	const pos = getPos();
	if (typeof pos !== "number") return null;
	// A gallery holds pictures only: its item has no line of text to join.
	if (editor.state.doc.resolve(pos).parent.type.name === "gallery") return null;

	const blocker = getInlineBlocker(editor.state.doc, pos);
	const toInline = () => {
		if (!editor || editor.isDestroyed) return;
		editor.chain().focus().imageToInline().run();
	};

	return (
		<GlassToolbarButton
			aria-label={label}
			disabled={Boolean(blocker)}
			disabledReason={blocker && t(inlineBlockerReasons[blocker])}
			onClick={toInline}
			tooltipText={label}
		>
			<GlassToolbarIcon icon="gallery-horizontal" />
		</GlassToolbarButton>
	);
};

export default ImageToInlineButton;
